module.exports = __webpack_public_path__ + "assets/fb351de099839269d9259c1d0bd6cb0f.mp4";